// The client-side twin of the SQL entitlement gate (COL-352).
//
// MUST match public.operator_has_active_subscription() and
// supabase/functions/_shared/entitlement.ts exactly: the platform operator is
// grandfathered and 'active' is the ONLY entitled status — past_due re-blocks.
// The server is the enforcement; this predicate only decides whether to show
// the paywall before the server refuses.
import type { SaasSubscriptionStatus } from "@/types/billing";

export type EntitlementStatus = SaasSubscriptionStatus | "none";

export function isEntitledToCreate(args: {
  isPlatform: boolean;
  status: EntitlementStatus;
}): boolean {
  return args.isPlatform || args.status === "active";
}
